import api from '../../utils/axios';

const sendClientChoseExpert = async (to, subject, firstName, lastName) => {
	const { data } = await api.post(`/emails/clients/expert/chose`, {
		to,
		subject,
		firstName,
		lastName,
	});

	return data;
};

const sendClientAppointmentExpert = async (
	userId,
	subject,
	firstName,
	lastName
) => {
	const { data } = await api.post(`/emails/clients/expert/appointment`, {
		userId,
		subject,
		firstName,
		lastName,
	});

	return data;
};

const sendClientContractExpert = async (
	userId,
	subject,
	firstName,
	lastName
) => {
	const { data } = await api.post(`/emails/clients/expert/contract`, {
		userId,
		subject,
		firstName,
		lastName,
	});

	return data;
};

const sendExpertAcceptClient = async (to, subject, firstName, lastName) => {
	const { data } = await api.post(`/emails/experts/client/accept`, {
		to,
		subject,
		firstName,
		lastName,
	});

	return data;
};

const sendExpertContractClient = async (to, subject, firstName, lastName) => {
	const { data } = await api.post(`/emails/experts/client/contract`, {
		to,
		subject,
		firstName,
		lastName,
	});

	return data;
};

const sendExpertRefusedClient = async (to, subject, firstName, lastName) => {
	const { data } = await api.post(`/emails/experts/client/refused`, {
		to,
		subject,
		firstName,
		lastName,
	});

	return data;
};

const emailService = {
	sendClientChoseExpert,
	sendExpertAcceptClient,
	sendExpertRefusedClient,
	sendClientAppointmentExpert,
	sendClientContractExpert,
	sendExpertContractClient,
};

export default emailService;
